

import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';

const initialState = {
  sidebarShow: true,
  asideShow: false,
  theme: 'light',
};

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest };
    default:
      return state;
  }
};

const logger = store => next => action => {
  let result = next(action);
  return result;
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(changeState, composeEnhancers(applyMiddleware(logger)));

export default store;